import {
  CustomerProfileSchema,
  OtpStartResponseSchema,
  TokenPairSchema,
  type SignupDataSchema,
} from '@paguz/contracts';
import type { z } from 'zod';
import { session } from '../auth/session.ts';
import { apiRequest, apiSend } from './client.ts';

/** `POST /v1/auth/otp/verify` → tokens + cliente (el contrato aún no publica este esquema: ver Solicitudes). */
export const OtpVerifyResponseSchema = TokenPairSchema.extend({ customer: CustomerProfileSchema });

/** Datos de registro de probador. `businessName` va además del contrato (ver Solicitudes). */
export type SignupPayload = z.input<typeof SignupDataSchema> & { businessName: string };

export const TERMS_VERSION = 'demo-2026-10';

/** `3001112233` / `300 111 2233` / `+57 300…` → `+573001112233` (o `null` si no es un celular). */
export function normalizePhone(input: string): string | null {
  const digits = input.replace(/\D/g, '');
  const local = digits.length === 12 && digits.startsWith('57') ? digits.slice(2) : digits;
  return /^3\d{9}$/.test(local) ? `+57${local}` : null;
}

export function startOtp(phone: string, purpose: 'LOGIN' | 'SIGNUP') {
  return apiRequest('/v1/auth/otp/start', OtpStartResponseSchema, {
    method: 'POST',
    body: { phone, purpose },
    auth: false,
  });
}

export async function verifyOtp(input: {
  challengeId: string;
  code: string;
  signupData?: SignupPayload;
}) {
  const result = await apiRequest('/v1/auth/otp/verify', OtpVerifyResponseSchema, {
    method: 'POST',
    body: input,
    auth: false,
  });
  session.setTokens(result);
  return result.customer;
}

export function getMe() {
  return apiRequest('/v1/customers/me', CustomerProfileSchema);
}

export async function logout(): Promise<void> {
  try {
    await apiSend('/v1/auth/logout', { method: 'POST' });
  } finally {
    session.clear();
  }
}
